const regex = /#[0-9A-Fa-f]{6}\b/;
export function isValidHexColor(value: string | null) {
  if (value == '' || value == null) return true;
  if (!regex.test(value)) return false;
  return true;
}
